import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";

import {ItemKey} from "./core/ItemKey";
import {ItemConfig} from "./ItemConfig";
import {ItemStateConfig} from "./ItemStateConfig";
import {MapGroupModel} from "@/modules/redactor/models/map/MapGroupModel";

export class ItemModel extends BaseObject {

  constructor() {
    super();
    this._key = null;
    this._config = null;
    this._scbuild = null;
    this._scmine = null;
    this._scharvest = null;
    this._scremove = null;
    this._scready = null;
    this._mapGroup = null;
  }

  get key() {
    return this._key;
  }

  set key(value) {
    this._key = value;
  }

  get config() {
    return this._config;
  }

  set config(value) {
    this._config = value;
  }

  get scbuild() {
    return this._scbuild;
  }

  set scbuild(value) {
    this._scbuild = value;
  }

  get scmine() {
    return this._scmine;
  }

  set scmine(value) {
    this._scmine = value;
  }

  get scharvest() {
    return this._scharvest;
  }

  set scharvest(value) {
    this._scharvest = value;
  }

  get scremove() {
    return this._scremove;
  }

  set scremove(value) {
    this._scremove = value;
  }

  get scready() {
    return this._scready;
  }

  set scready(value) {
    this._scready = value;
  }

  get mapGroup() {
    return this._mapGroup;
  }

  set mapGroup(value) {
    this._mapGroup = value;
  }

  valid() {

    if (!this.key || !this.key.valid() || this.key.any() || this.key.complex()) {
      return false;
    }

    if (!this.config || !this.config.valid()) {
      return false;
    }

    if (this.scbuild && !this.scbuild.valid()) {
      return false;
    }

    if (this.scmine && !this.scmine.valid()) {
      return false;
    }

    if (this.scharvest && !this.scharvest.valid()) {
      return false;
    }

    if (this.scremove && !this.scremove.valid()) {
      return false;
    }

    if (this.scready && !this.scready.valid()) {
      return false;
    }

    return true;
  }

  copy() {
    return super.copy();
  }

  clone(target = undefined) {
    if (!target) {
      return super.clone(new ItemModel());
    } else if (target instanceof ItemModel) {
      return super.clone(target);
    } else {
      console.assert(false);
      return undefined;
    }
  }
}

createModelSchema(ItemModel, {
  _key: alias("key", ItemKey.schema()),
  _config: alias("config", ItemConfig.schema()),
  _scbuild: alias("st_build", ItemStateConfig.schema()),
  _scmine: alias("st_mine", ItemStateConfig.schema()),
  _scharvest: alias("st_harvest", ItemStateConfig.schema()),
  _scremove: alias("st_remove", ItemStateConfig.schema()),
  _scready: alias("st_ready", ItemStateConfig.schema()),
  _mapGroup: alias("map_group", MapGroupModel.schema()),
});
